import React, { useState, useEffect } from 'react';
import { FaPlus, FaEdit, FaTrash, FaSave, FaTimes } from 'react-icons/fa';
import { authFetch, getAuthHeaders } from './authHelper';

const AdminTexts = () => {
  const [texts, setTexts] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ text_key: '', text_value: '', section: 'general' });
  const [loading, setLoading] = useState(true);

  const fetchTexts = () => {
    authFetch('/api/admin/texts.php')
      .then((res) => res.json())
      .then((data) => { setTexts(Array.isArray(data) ? data : []); setLoading(false); })
      .catch(() => setLoading(false));
  };

  useEffect(() => { fetchTexts(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await authFetch('/api/admin/texts.php', {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(form),
    });
    setEditing(null);
    setForm({ text_key: '', text_value: '', section: 'general' });
    fetchTexts();
  };

  const handleEdit = (text) => {
    setEditing(text.id);
    setForm({ text_key: text.text_key, text_value: text.text_value, section: text.section });
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer ce texte ?')) return;
    await authFetch(`/api/admin/texts.php?id=${id}`, { method: 'DELETE' });
    fetchTexts();
  };

  if (loading) return <div className="admin-loading">Chargement...</div>;

  return (
    <div>
      <div className="admin-page-header">
        <h2 className="admin-page-title">Textes du site</h2>
        {editing === null && (
          <button className="btn btn-primary btn-sm" onClick={() => setEditing('new')}>
            <FaPlus /> Ajouter
          </button>
        )}
      </div>

      {editing !== null && (
        <form className="admin-form" onSubmit={handleSubmit}>
          <h3>{editing === 'new' ? 'Nouveau texte' : 'Modifier le texte'}</h3>
          <div className="admin-form-grid">
            <div className="admin-field">
              <label>Clé *</label>
              <input
                type="text"
                value={form.text_key}
                onChange={(e) => setForm({ ...form, text_key: e.target.value })}
                required
                placeholder="hero_title"
                disabled={editing !== 'new'}
              />
            </div>
            <div className="admin-field">
              <label>Section</label>
              <select value={form.section} onChange={(e) => setForm({ ...form, section: e.target.value })}>
                <option value="general">Général</option>
                <option value="accueil">Accueil</option>
                <option value="services">Services</option>
                <option value="tarifs">Tarifs</option>
                <option value="a-propos">À propos</option>
                <option value="contact">Contact</option>
              </select>
            </div>
            <div className="admin-field full-width">
              <label>Contenu *</label>
              <textarea
                value={form.text_value}
                onChange={(e) => setForm({ ...form, text_value: e.target.value })}
                rows="4"
                required
              />
            </div>
          </div>
          <div className="admin-form-actions">
            <button type="submit" className="btn btn-primary btn-sm"><FaSave /> Enregistrer</button>
            <button type="button" className="btn btn-secondary btn-sm" onClick={() => { setEditing(null); setForm({ text_key: '', text_value: '', section: 'general' }); }}>
              <FaTimes /> Annuler
            </button>
          </div>
        </form>
      )}

      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead>
            <tr>
              <th>Clé</th>
              <th>Section</th>
              <th>Contenu</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {texts.length === 0 ? (
              <tr><td colSpan="4" className="admin-empty">Aucun texte enregistré</td></tr>
            ) : (
              texts.map((t) => (
                <tr key={t.id}>
                  <td><code>{t.text_key}</code></td>
                  <td>{t.section}</td>
                  <td>{t.text_value.substring(0, 100)}{t.text_value.length > 100 ? '...' : ''}</td>
                  <td className="admin-actions">
                    <button onClick={() => handleEdit(t)} title="Modifier"><FaEdit /></button>
                    <button onClick={() => handleDelete(t.id)} title="Supprimer" className="danger"><FaTrash /></button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminTexts;
